import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ml-4"},[_c(VBtn,{attrs:{"color":"primary","small":""},on:{"click":function($event){return _setup.exportarItens()}}},[_vm._v("Exportar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }